import React, { useState } from 'react'
import { Card, CardContent, Grid, makeStyles, Typography, InputLabel, Select, MenuItem, Avatar, Box } from '@material-ui/core'
import LineChart from '../../chartsData/LinechartLeaves'
import Barchart from '../../chartsData/BarChartAttend'
import Profilepic from '../../assets/images/profilepic.PNG'
import MultilineChart from '../../chartsData/MultipleLineChart'
import PieChart from '../../chartsData/PieChartdata'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import CancelIcon from '@material-ui/icons/Cancel'
import { Line, Pie } from 'react-chartjs-2'
import Loader from '../Loader'
import { AiFillCheckCircle, AiOutlineCheckCircle } from 'react-icons/ai'
import { MdCancel } from 'react-icons/md'
import { GiCancel } from 'react-icons/gi'
import CustomLabel from '../CustomLabel'
import SkeletonLoader from '../SkeletonLoader'
import { useLeave } from '../../hooks/Features/useLeaves'
import ApproveDialog from '../Dialog/ApproveDialog'
import { months } from '../../shared/data'
import LeavePieChart from '../Charts/LeavePieChart'
import CardWithChart from '../CardWithChart'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#F5F8FF',
    justifyContent: 'center',
    border: 'none',
    borderRadius: '12px',
    // boxShadow:'none'
  },
  icon: {
    width: '22px',
    height: '22px',
    cursor: 'pointer',
    marginLeft: '22px',
    // marginTop: '4px',
  },
  icons: {
    marginLeft: '20px',
    cursor: 'pointer',
  },
  underline: {
    borderBottom: '1px solid #CCCCCC',
    marginTop: '2px',
  },
  subtitle: {
    fontSize: '28px',
    fontWeight: 'bold',
    letterSpacing: '0.5px',
    lineHeight: ' 38px',
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
  },
  title1: {
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '19px',
    letter: '0.5px',
    margin: 5,
    color: '#313131',
    paddingBottom: '30px',
  },
  title4: {
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '19px',
    margin: 3,
    color: '#313131',
    paddingBottom: '4px',
  },
  title2: {
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '14px',
    margin: 5,
    color: '#313131',
  },
  image: {
    // borderRadius: '45%',
    // height: '9%',
    width: '45px',
    height: '45px',
  },
  label: {
    fontSize: '12px',
  },
  srollbar: {
    height: '580px',
    overflowY: 'scroll',
    '&::-webkit-scrollbar': {
      width: '0.3em',
      borderRadius: '2px',
    },
    // '&::-webkit-scrollbar-track': {
    //   boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
    //   webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
    // },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#CCCCCC',
      // outline: '1px solid slategrey',
    },
  },
}))

export default function DashLayout({
  leavesRecord,
  leaveThisWeek = [],
  setApproveDialog,
  setRejectDialog,
  monthLeave,
  leave,
  setLeave,
  approveDialog,
  handleApproveClose,
  approveLeaveRequest,
  rejectDialog,
  handleRejectClose,
  loading,
  leaves,
  companyAdmin,
}) {
  const classes = useStyles()

  var myData =
    leaves &&
    leaves.leaveMonthWise &&
    Object.keys(leaves.leaveMonthWise).map((key) => {
      return leaves.leaveMonthWise[key]
    })

  const graphData = (canvas) => {
    const ctx = canvas.getContext('2d')
    const gradient1 = ctx.createLinearGradient(10, 10, 255, 1)
    gradient1.addColorStop(0, ' lightblue')
    gradient1.addColorStop(1, '#F5F8FF')
    return {
      labels: months,
      datasets: [
        {
          label: 'Leave',
          data: myData,
          pointBackgroundColor: 'rgba(51, 73, 159, 1)',
          pointBorderColor: '#fff',
          borderColor: 'rgba(51, 73, 159, 0.8)',
          backgroundColor: 'rgba(51, 73, 159, 0.1)',
          tension: 0,
          fill: true,
        },
      ],
    }
  }

  const fetchStatus = (type) => {
    switch (type) {
      case 'APPROVED':
        return (
          <Box display="flex" justifyContent="flex-start" alignContent="center" style={{ marginTop: '3px' }}>
            {' '}
            <AiFillCheckCircle style={{ color: 'green', fontSize: '15px', cursor: 'pointer', marginRight: '10px', marginTop: '2px' }} /> <CustomLabel label={'Accepted'} className={classes.label} />
          </Box>
        )
      case 'REJECTED':
        return (
          <Box display="flex" justifyContent="flex-start" alignContent="center" style={{ marginTop: '3px' }}>
            <MdCancel style={{ color: 'red', fontSize: '15px', cursor: 'pointer', marginRight: '10px', marginTop: '2px' }} />
            <CustomLabel label={'Rejected'} className={classes.label} />
          </Box>
        )

      default:
        return (
          <Box display="flex" justifyContent="space-evenly" alignContent="center" style={{ marginTop: '3px' }}>
            <AiOutlineCheckCircle style={{ color: 'green', fontSize: '15px', cursor: 'pointer', marginRight: '10px', marginTop: '2px' }} onClick={() => setApproveDialog(true)} />
            <GiCancel style={{ color: 'red', fontSize: '15px', cursor: 'pointer', marginTop: '2px' }} onClick={() => setRejectDialog(true)} />
          </Box>
        )
    }
  }
  //console.log('leavesRecord', leavesRecord)
  const calculateTotalDays = (from, to) => {
    const date1 = new Date(to)
    const date2 = new Date(from)
    const diffTime = Math.abs(date2 - date1)
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

    return diffDays + 1
  }
  return (
    <Grid container direction="row" justify="center" alignItems="flex-start" spacing={2} style={{ paddingRight: '12px', paddingLeft: '10px', width: '100%' }}>
      <Grid item lg={9} container spacing={2}>
        <Grid item lg={3}>
          <Card variant="outlined" className={classes.root}>
            <CardContent
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <p style={{ fontSize: '14px', fontFamily: 'Open Sans', fontWeight: 600 }}>Total</p>
              <br />

              <Typography className={classes.subtitle}> {loading ? <Loader /> : leaves.totalLeaves} </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item lg={3}>
          <Card variant="outlined" className={classes.root}>
            <CardContent
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <p style={{ fontSize: '14px', fontFamily: 'Open Sans', fontWeight: 600 }}>Accepted</p>
              <br />

              <Typography className={classes.subtitle}>{loading ? <Loader /> : leaves.totalApproved}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item lg={3}>
          <Card variant="outlined" className={classes.root}>
            <CardContent
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <p style={{ fontSize: '14px', fontFamily: 'Open Sans', fontWeight: 600 }}>Rejected</p>
              <br />

              <Typography className={classes.subtitle}>{loading ? <Loader /> : leaves.totalRejected}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item lg={3}>
          <Card variant="outlined" className={classes.root}>
            <CardContent
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <p style={{ fontSize: '14px', fontFamily: 'Open Sans', fontWeight: 600 }}>Pending</p>
              <br />

              <Typography className={classes.subtitle}>{loading ? <Loader /> : leaves.totalNotApproved}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item lg={7} style={{ flexWrap: 'wrap' }}>
          <Card variant="outlined" className={classes.root} style={{ height: '100%' }}>
            {!loading ? (
              <CardContent style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                <Typography className={classes.title1}>Leaves per month</Typography>
                <div style={{ height: '320px' }}>
                  <Line data={graphData} options={LineChart.LinedataLeaveoptions} />
                </div>
              </CardContent>
            ) : (
              <Loader />
            )}
          </Card>
        </Grid>
        <Grid item lg={5}>
          <CardWithChart heading="Accepted Vs Rejected Leaves" noMarginTop>
            <LeavePieChart leavesRecord={!loading && leaves} />
          </CardWithChart>
        </Grid>
      </Grid>
      <Grid item lg={3} style={{ marginTop: '1px' }} className={classes.srollbar}>
        <Card variant="outlined" className={classes.root}>
          <CardContent style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
            <Typography className={classes.title4}>Leave Request This Week</Typography>
            {!loading ? (
              leaves.leaveRequestThisWeek &&
              leaves.leaveRequestThisWeek.map((item, index) => {
                let leavesTaken = item.employeeId && calculateTotalDays(item.leaveFrom, item.leaveTo)
                return (
                  <div>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-start',
                        paddingBottom: '12px',
                      }}
                    >
                      <div style={{ paddingTop: '10px', width: '45px ', height: '45px ' }}>
                        <Avatar src={item.employeeId && item.employeeId.profilePicture} className={classes.image} />
                      </div>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'center',
                          paddingLeft: '15px',
                          paddingTop: '4px',
                        }}
                      >
                        <Typography className={classes.title2}>{item.employeeId && item.employeeId.firstName} </Typography>
                        <Typography style={{ marginLeft: '3px', fontSize: '12px' }}>{item.employeeId && item.employeeId.position && item.employeeId.position.positionName} </Typography>
                        <Typography style={{ marginLeft: '3px', fontSize: '12px' }}>{`Total : ${leavesTaken} Day${leavesTaken > 1 ? 's' : ''}`} </Typography>
                        {companyAdmin && <div onClick={() => setLeave(item)}>{fetchStatus(item.leaveApproved)}</div>}
                      </div>
                    </div>
                    {leaves.leaveRequestThisWeek.length - 1 === index ? null : <div className={classes.underline} style={{ width: '100%' }}></div>}
                  </div>
                )
              })
            ) : (
              <SkeletonLoader />
            )}
            {!loading && leaves.leaveRequestThisWeek && leaves.leaveRequestThisWeek.length === 0 && (
              <Typography className={classes.title4} style={{ paddingLeft: '20px' }}>
                No Leave Requests This Week
              </Typography>
            )}
          </CardContent>
        </Card>

        {leave ? <ApproveDialog open={approveDialog} handleClose={handleApproveClose} name={leave.employeeId && leave.employeeId.firstName} approve handleSubmit={approveLeaveRequest} /> : null}
        {leave ? <ApproveDialog open={rejectDialog} handleClose={handleRejectClose} name={leave.employeeId && leave.employeeId.firstName} handleSubmit={approveLeaveRequest} /> : null}
      </Grid>
    </Grid>
  )
}
